import i18n, { LOCALE_CONFIG, DEFAULT_LANGUAGE } from '../i18n';

const currentLocale = () => {
  const lng = (i18n.language || DEFAULT_LANGUAGE).split('-')[0];
  return LOCALE_CONFIG[lng] || LOCALE_CONFIG[DEFAULT_LANGUAGE];
};

export const formatDate = (value, opts = { dateStyle: 'medium' }) => {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat(currentLocale().intlLocale, opts).format(d);
};

export const formatDateTime = (value) =>
  formatDate(value, { dateStyle: 'short', timeStyle: 'short' });

export const formatTime = (value) =>
  formatDate(value, { timeStyle: 'short' });

export const formatNumber = (value, opts = {}) => {
  if (value === null || value === undefined || value === '') return '';
  const n = typeof value === 'number' ? value : Number(value);
  if (isNaN(n)) return '';
  return new Intl.NumberFormat(currentLocale().intlLocale, opts).format(n);
};

export const formatCurrency = (value, currency) => {
  if (value === null || value === undefined || value === '') return '';
  const n = typeof value === 'number' ? value : Number(value);
  if (isNaN(n)) return '';
  const { intlLocale, currency: defaultCurrency } = currentLocale();
  return new Intl.NumberFormat(intlLocale, {
    style: 'currency',
    currency: currency || defaultCurrency,
  }).format(n);
};

export const formatRelativeTime = (value) => {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return '';
  const diff = Date.now() - d.getTime();
  const mins = Math.floor(diff / 60000);
  const t = i18n.t.bind(i18n);
  if (mins < 1) return t('sidebar.relative.now');
  if (mins < 60) return t('sidebar.relative.minutesAgo', { count: mins });
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return t('sidebar.relative.hoursAgo', { count: hrs });
  const days = Math.floor(hrs / 24);
  if (days < 7) return t('sidebar.relative.daysAgo', { count: days });
  return formatDate(d, { day: '2-digit', month: 'short' });
};
